module.exports = __webpack_public_path__ + "img/pdf_icon.02534ec7.png";